module.exports = __webpack_public_path__ + "img/eu-flag.c2488419.svg";